import React, { memo } from 'react';

import PropTypes from 'prop-types';

const HighlightText = ({ text, highlight }) => {
  if (!highlight) {
    return text;
  }

  const parts = text.split(new RegExp(`(${highlight})`, 'gi'));

  return parts.map((part, index) =>
    part.toLowerCase() === highlight.toLowerCase() ? <mark key={index}>{part}</mark> : part,
  );
};

HighlightText.propTypes = {
  text: PropTypes.string.isRequired,
  highlight: PropTypes.string.isRequired,
};

export default memo(HighlightText);
